import { shade, tint, parseToRgb } from 'polished';
const colors = {
    primary: '#04b440',
    gray: '#F9F9F9',
    success: '#1B84FF',
    info: '#7239EA',
    warning: '#F6C000',
    danger: '#f8285a',
    dark: '#0D0D0D',
    blue: '#0d6efd',
    indigo: '#6610f2',
    purple: '#6f42c1',
    pink: '#d63384',
    red: '#dc3545',
    orange: '#fd7e14',
    yellow: '#ffc107',
    green: '#198754',
    teal: '#20c997',
    cyan: '#0dcaf0',
    black: '#000000',
    white: '#ffffff',
};
export default {
    colors: {
        primary: colors.primary,
        primaryLight: tint(.92, colors.primary),
        primaryDark: shade(0.2, colors.primary),
        gray: shade(.60, colors.gray),
        grayDark: shade(.80, colors.gray),
        // gray100: colors.gray,
        // gray200: shade(.10, colors.gray),
        // gray300: shade(.30, colors.gray),
        // gray400: shade(.40, colors.gray),
        // gray500: shade(.50, colors.gray),
        // gray600: shade(.60, colors.gray),
        // gray700: shade(.70, colors.gray),
        // gray800: shade(.80, colors.gray),
        // gray900: shade(.90, colors.gray),
        gray100: "#F9F9F9",
        gray100Rgb: "249, 249, 249",
        gray200: "#F1F1F4",
        gray200Rgb: "241, 241, 244",
        gray300: "#eaeaea",
        gray300Rgb: "234,234,234",
        gray400: "#C4CADA",
        gray400Rgb: "196, 202, 218",
        gray500: "#99A1B7",
        gray500Rgb: "153, 161, 183",
        gray600: "#78829D",
        gray600Rgb: "120, 130, 157",
        gray700: "#4B5675",
        gray700Rgb: "75, 86, 117",
        gray800: "#252F4A",
        gray800Rgb: "37, 47, 74",
        gray900: "#071437",
        gray900Rgb: "7, 20, 55",
        secondary: shade(.10, colors.gray),
        light: colors.gray,
        black: colors.black,
        white: colors.white,
        success: colors.success,
        info: colors.info,
        warning: colors.warning,
        danger: colors.danger,
        dark: colors.dark,
        blue: colors.blue,
        indigo: colors.indigo,
        purple: colors.purple,
        pink: colors.pink,
        red: colors.red,
        orange: colors.orange,
        yellow: colors.yellow,
        green: colors.green,
        teal: colors.teal,
        cyan: colors.cyan,
    },
    rgbColors: {
        lightRgb: parseToRgb(colors.gray),
        primaryRgb: parseToRgb(colors.primary),
        secondaryRgb: parseToRgb(shade(.10, colors.gray)),
        successRgb: parseToRgb(colors.success),
        infoRgb: parseToRgb(colors.info),
        warningRgb: parseToRgb(colors.warning),
        dangerRgb: parseToRgb(colors.danger),
        darkRgb: parseToRgb(colors.dark),
        whiteRgb: parseToRgb(colors.white),
        blackRgb: parseToRgb(colors.black),
    },
    textEmphasis: {
        primary: colors.dark,
        secondary: '#606062',
        success: '#1B84FF',
        info: '#7239EA',
        warning: '#F6C000',
        danger: '#F8285A',
        light: colors.gray,
        dark: colors.dark,
        muted: '#99A1B7',
    },
    backgrounds: {
        bodyBackground: '#f4f5f7',
        primarySubtle: '#d1e6ff',
        secondarySubtle: '#fcfcfd',
        successSubtle: '#d1f4dd',
        infoSubtle: '#e3d7fb',
        warningSubtle: '#fdf2cc',
        dangerSubtle: '#fed4de',
        lightSubtle: '#fcfcfc',
        darkSubtle: '#C4CADA',
    },
    borders: {
        primarySubtle: '#a4ceff',
        secondarySubtle: '#f9f9fb',
        successSubtle: '#a2e8ba',
        infoSubtle: '#c7b0f7',
        warningSubtle: '#fbe699',
        dangerSubtle: '#fca9bd',
        lightSubtle: '#F1F1F4',
        darkSubtle: '#99A1B7',
        default: {
            width: '1px',
            style: 'solid',
            color: '#F1F1F4',
            colorTranslucent: 'rgba(0, 0, 0, 0.175)',
        },
        radius: {
            default: '0.65rem',
            sm: '0.55rem',
            lg: '1rem',
            xl: '1.25rem',
            xxl: '2rem',
            pill: '50rem',
        },
    },
    typography: {
        base: [
            '"Inter"',
            '"HelveticaNeue-Light"',
            '"Helvetica Neue Light"',
            '"Helvetica Neue"',
            'Helvetica',
            'Arial',
            '"Lucida Grande"',
            'sans-serif',
        ].join(','),
        fontMonospace: 'SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace',
        bodyFontFamily: 'Inter, Helvetica, sans-serif',
        bodyFontSize: '1rem',
        bodyFontWeight: 400,
        bodyLineHeight: 1.5,
        bodyColor: '#071437',
        bodyColorRgb: '7, 20, 55',
        bodyBg: '#ffffff',
        bodyBgRgb: '255, 255, 255',
        emphasisColor: '#000000',
        emphasisColorRgb: '0, 0, 0',
        secondaryColor: 'rgba(7, 20, 55, 0.75)',
        secondaryColorRgb: '7, 20, 55',
        tertiaryColor: 'rgba(7, 20, 55, 0.5)',
        tertiaryColorRgb: '7, 20, 55',
        tertiaryBg: '#F9F9F9',
        tertiaryBgRgb: '249, 249, 249',
        headingColor: '#071437',
        linkColor: '#1B84FF',
        linkHoverColor: '#056EE9',
    },
    shadows: {
        default: '0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075)',
        sm: '0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05)',
        lg: '0 1rem 2rem 1rem rgba(0, 0, 0, 0.1)',
        inset: 'inset 0 1px 2px rgba(0, 0, 0, 0.075)',
    },
    space: {
        space0: "0rem",
        space025: ".0625rem",
        space050: ".125rem",
        space100: ".25rem",
        space150: ".375rem",
        space200: ".5rem",
        space300: ".75rem",
        space400: "1rem",
        space500: "1.25rem",
        space600: "1.5rem",
        space800: "2rem",
        space1000: "2.5rem",
        space1200: "3rem",
        space1600: "4rem",
        space2000: "5rem",
        space2400: "6rem",
        space2800: "7rem",
        space3200: "8rem",
    },
};
